//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";

const location = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getLocations(pagination, loyaltyId) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let res = await fetch(
        `${config.host}/cdr-panel/api/location?offset=${pagination.offset}&limit=${pagination.limit}&loyaltyId=${loyaltyId}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function searchLocation(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      const res = await fetch(
        `${config.host}/cdr-panel/api/location/search?search=${encodeURIComponent(values.searchBounceValues)}&offset=${values.offset}&limit=${values.limit}&loyaltyId=${values.loyaltyId}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function selectCustomerAccount(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/api/location/select-customer-account`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

    async function dormantaccount(values) {
      try {
        const obj = {
          method: "POST",
          credentials: 'include',
          headers: {
            "Content-Type": "application/json"          
          },
          body: JSON.stringify(values),
        };
        let res = await fetch(`${config.host}/cdr-panel/api/location/dormant-update`, obj);
        return handleResponse(res);
      } catch (err) {
        handleError(err);
      }
  }

  return {
    getLocations,
    searchLocation,
    selectCustomerAccount,
    dormantaccount
  };
};

export default location;
